export default __webpack_public_path__ + "static/media/di1.c7afb56b.jpg";